export default {"src":"/_next/static/media/LogoIpsum5.916d0fcf.svg","height":30,"width":78,"blurWidth":0,"blurHeight":0};